/**
 * API Configuration and Fetch Utilities
 * Extracted from App.js - Phase 7B Frontend Refactor
 */
import axios from "axios";

// Resolve backend URL. Backend is served on the same origin as the
// frontend (backend routes prefixed with /api are proxied through the
// ingress), so window.location.origin is correct for every deployment
// target — preview, custom prod domain (e.g. app.verifieddemand.com),
// and default emergent.host prod domain alike. The env var fallback
// is only needed for SSR / build-time contexts where `window` is
// undefined.
const getBackendUrl = () => {
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const BACKEND_URL = getBackendUrl();
export const API_BASE = `${BACKEND_URL}/api`;

/**
 * Create an axios instance with default config
 */
export const apiClient = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Add auth token to requests if available
 */
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * API endpoint constants for demand intelligence
 */
export const ENDPOINTS = {
  // Auth
  AUTH_LOGIN: "/auth/login",
  AUTH_REGISTER: "/auth/register",
  AUTH_ME: "/auth/me",
  AUTH_FORGOT_PASSWORD: "/auth/forgot-password",
  AUTH_RESET_PASSWORD: "/auth/reset-password",
  AUTH_REQUEST_OTP: "/auth/request-otp",
  AUTH_VERIFY_OTP: "/auth/verify-otp",
  
  // Demand Intelligence
  DEMAND_SCORES: "/demand/scores",
  DEMAND_SCORES_SUMMARY: "/demand/scores/summary",
  DEMAND_SCORES_VEHICLES: "/demand/scores/vehicles",
  DEMAND_SCORES_MARKETING: "/demand/scores/marketing",
  DEMAND_SCORES_GEOGRAPHIC: "/demand/scores/geographic",
  DEMAND_ZIP_NEARBY_EXECUTIVE: "/demand/zip-nearby-executive",
  DEMAND_ALERTS: "/demand/alerts",
  DEMAND_MOMENTUM: "/demand/momentum",
  DEMAND_OFFER_VISIBILITY: "/demand/offer-visibility",
  
  // Business
  OFFERS: "/offers",
  LEADS: "/leads",
  
  // Analytics
  ANALYTICS_OVERVIEW: "/analytics/overview",
  ANALYTICS_GEOGRAPHY: "/analytics/geography",
  ANALYTICS_CAMPAIGNS: "/analytics/campaigns",
  ANALYTICS_DEVICES: "/analytics/devices",
  ANALYTICS_REFERRERS: "/analytics/referrers",
  
  // Settings
  SETTINGS_BUSINESS: "/settings/business",
  SETTINGS_STATUS: "/settings/status",
  SETTINGS_DEALER_LOCATION: "/settings/dealer-location",
  SETTINGS_DEMO_DATA: "/settings/demo-data",
};
